import styled from "styled-components";
import { Flex } from "discover.medical.react-component-library";
import Hierarchy from "./Hierarchy";

export const TOC = styled(Hierarchy)`
  width: 100%;
`;

export const Column = styled(Flex)`
  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.space.lg};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    &:not(:first-child) {
      padding-left: ${({ theme }) => theme.space.lg};
    }
    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
`;
